app.filter('split', function () {
    return function (input, splitChar, splitIndex) {
        // do some bounds checking here to ensure it has that index
        return input.toString().split(splitChar)[splitIndex];
    }
});